/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUsersReport,
} from '../actions/reports.action';

const initialState = {
  userReportStatus: 'idle',
};

const reportSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersReport.fulfilled, (state, action) => {
        state.userReportStatus = 'complete';
      })
      .addCase(fetchUsersReport.pending, (state, action) => {
        state.userReportStatus = 'loading';
      })
      .addCase(fetchUsersReport.rejected, (state, action) => {
        state.userReportStatus = 'failed';
      });
  },
});

export default reportSlice.reducer;
